module.exports = __webpack_public_path__ + "img/module6_5.d710c2f3.png";